import script from "./PelLoanOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./PelLoanOptions.vue?vue&type=script&setup=true&lang=ts"

import "./PelLoanOptions.vue?vue&type=style&index=0&id=2503ad0f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2503ad0f"]])

export default __exports__